import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import {
  InsertType,
  components
} from '@app/modules/fast-cadastro/components/fast-autocomplete/fast-autocomplete.component';
import { PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';
import { finalize } from 'rxjs/operators';
import {
  DeepPartial,
  EntityService,
  ErroMessages,
  FormList,
  IErroMessages,
  IErrorResponse,
  TokenService,
  ViggoCoreColumnDef
} from 'viggo-sistemas-core-web';
import { ConfirmDialogComponent, ConfirmDialogData, SELECT } from '..';
interface IFieldConfig {
  label: string;
  control: UntypedFormControl;
  class: string;
  display_search: string;
  type?: string;
  selectOptions?: SELECT[];
  selectedValue?: string;
  mask?: string;
}

export interface DialogSearchData {
  entityService: EntityService<any>;
  entityName: string;
  urlEntity: string;
  columnDefs: ViggoCoreColumnDef<any>[];
  itensColumnDefs: ViggoCoreColumnDef<any>[];
  title: string;
  fields: IFieldConfig[];
  domain_path?: string;
  params_path?: string;
  params?: string;
  selectOnlyOne?: boolean;
  addBtn?: boolean;
  insertType?: string;
  include?: string[];
  order_by?: string[];
  useTableExpanded?: boolean;
  anotherDirection?: boolean; // usado comumente para usar outra rota de list - inicialmente colocada pra grade de produtos
}

@Component({
  selector: 'dialog-search',
  templateUrl: 'dialog-search.component.html',
  styleUrls: ['./dialog-search.component.scss'],
  providers: [DatePipe]
})
export class DialogSearchComponent extends FormList<any> implements OnInit {
  entityService: any;
  dialogDataSearch = {} as DialogSearchData;
  pageLength = 0;
  page = 0;
  first = 0;
  rows = 0;
  page_size = 0;
  requisitions = 0;
  stateSearch = false;
  noResults = false;
  selectOnlyOne = false;
  addBtn = false;
  domain_path = 'domain_id';
  params: string;
  params_path: string;
  pageSizeOptions = [5, 10, 20, 50];
  insertType: InsertType | null = null;
  data: any = {};
  maxDate = new Date();
  useTableExpanded = false;
  anotherDirection = false;
  itensColumnDefs: ViggoCoreColumnDef<any>[];
  dataSelection: any[] = [];
  dataItensSelection: any[] = [];

  @ViewChild('tableExpanded') tableExpanded: Table;
  @ViewChild('tableEntitiesExpanded') tableEntitiesExpanded: Table;

  // USADA PARA COMPARAR OS ITENS DE UMA ENTITY SELECIONADOS
  keySubEntityCompare = 'variacao_id';

  // USADA PARA CHECAR SE A REFERENCIA QUE TEM NOS ITENS PERTENCE A ALGUMA DAS ENTITIES
  keyEntityCompare = 'id';

  idRowUnselect = '';

  constructor(
    protected tokenService: TokenService,
    protected matDialogRef: MatDialogRef<DialogSearchComponent>,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    private primengConfig: PrimeNGConfig,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    super({
      usePagination: true,
      entityName:
        data.entityName !== null && data.entityName !== undefined
          ? data.entityName
          : 'data',
      urlEntity: data.urlEntity,
      KEY_DATA_NOT_SELECTION: `DATA_NOT_SELECTION_${data.entityName.toUpperCase()}_DIALOG_SEARCH`,
      KEY_DATA_SELECTION: `DATA_SELECTION_${data.entityName.toUpperCase()}_DIALOG_SEARCH`,
      KEY_DATA_ALL_SELECTED: `SELECTED_ALL_TABLE_${data.entityName.toUpperCase()}_DIALOG_SEARCH`
    });
    this.primengConfig.ripple = true;
    this.dialogDataSearch = data;
    this.entityService = data.entityService;
    this.include = data.include;
    this.order_by = data.order_by;
    this.columnDefs = data.columnDefs;
    if (data.insertType) this.insertType = data.insertType;
    if (data.domain_path) this.domain_path = data.domain_path;
    if (data.params) this.params = data.params;
    if (data.params_path) this.params_path = data.params_path;
    if (data.selectOnlyOne) this.selectOnlyOne = data.selectOnlyOne;
    if (data.addBtn) this.addBtn = data.addBtn;
    if (data.useTableExpanded) this.useTableExpanded = data.useTableExpanded;
    if (data.itensColumnDefs) this.itensColumnDefs = data.itensColumnDefs;
    if (data.anotherDirection) this.anotherDirection = data.anotherDirection;
  }

  public ngOnInit() {
    this.onLoadPagination(0, false, true);
  }

  enterSearch(event) {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  public onClearKeyword(): void {
    this.dialogDataSearch.fields.forEach(keyword => {
      keyword.control.reset();
      keyword.control.reset();
      keyword.control.reset();
      keyword.control.reset();
    });
    this.onLoadPagination(0, false, true);
  }

  public clearFilter(control: UntypedFormControl): void {
    // this.dialogDataSearch.fields.forEach(keyword => {
    //   if(keyword.type === 'status') keyword.control.reset();
    // });
    control.reset();
    this.onLoadPagination(0, false, true);
  }

  override onLoadPagination(page = 0, reload?: boolean, notFirstReq?: boolean) {
    if (notFirstReq) this.requisitions = 0;
    this.requisitions += 1;
    if (this.requisitions === 1) {
      this.entities = [];
      this.filterEntities = [];
      this.loading = true;
      this.page = reload ? this.page : page;
      this.page_size = Number(localStorage.getItem('PAGINATOR_SIZE') || 5);

      if (this.stateSearch) this.onSearch(0, reload);
      else {
        var params = `page=${this.page}&page_size=${
          this.page_size
        }&list_options=${this.statusEntities}&${this.domain_path}=${
          this.tokenService.getDomain().id
        }`;

        if (this.include) params += `&include=${this.include}`;
        if (this.order_by) params += `&order_by=${this.order_by}`;
        if (this.params_path) params += `&${this.params_path}=${this.params}`;

        const req = this.anotherDirection
          ? this.entityService.getEntitiesByParams(
              params,
              this.tokenService.getDomain().id,
              true,
              this.anotherDirection
            )
          : this.entityService.getEntitiesByParams(
              params,
              this.tokenService.getDomain().id,
              true
            );

        req
          .pipe(
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe(
            entities => {
              this.entities = entities.data;
              this.page = entities.pagination.page;
              this.pageLength = entities.pagination.total;
            },
            (err: HttpErrorResponse) => {
              this.errorResponse = {
                title: 'Erro detectado',
                message: err.message,
                status: err.status.toString(),
                statusError: err.statusText
              } as IErrorResponse;
              this.displayError(err, true);
            },
            () => {
              this.loading = false;
              this.filterEntities = this.entities;
            }
          );
      }
    }
  }

  override onSearch(page = 0, reload?): void {
    this.stateSearch = true;
    this.entities = [];
    this.filterEntities = [];
    this.loading = true;
    this.page = reload ? this.page : page;
    let where: DeepPartial<unknown> = {};
    this.page_size = Number(localStorage.getItem('PAGINATOR_SIZE') || 20);
    where[this.domain_path] = this.tokenService.getDomain().id;
    if (this.params_path) where[this.params_path] = this.params;

    this.dialogDataSearch.fields.forEach(keyword => {
      if (keyword.control.value !== '' && keyword.control.value !== null) {
        if (keyword.type && keyword.type === 'number')
          where[keyword.display_search] = keyword.control.value;
        else if (keyword.type && keyword.type === 'status')
          where[keyword.display_search] = keyword.control.value.value;
        else if (keyword.type && keyword.type === 'data') {
          var date = new Date(keyword.control.value);
          var dateString = `${date.getFullYear()}-${date.getUTCMonth() +
            1}-${date.getDate()}`;
          where[keyword.display_search] = dateString;
        } else
          where[keyword.display_search] = '%' + keyword.control.value + '%';
      }
    });

    var objParams = {
      pagination: {
        page: page,
        page_size: this.page_size
      },
      list_options: this.statusEntities,
      where: where
    } as any;

    if (this.include) objParams = { ...objParams, include: this.include };

    if (this.order_by) objParams = { ...objParams, order_by: this.order_by };

    const req = this.anotherDirection
      ? this.entityService.getEntitiesByParams(
          objParams,
          this.tokenService.getDomain().id,
          true,
          this.anotherDirection
        )
      : this.entityService.getEntitiesByParams(
          objParams,
          this.tokenService.getDomain().id,
          true
        );

    req.subscribe(
      entities => {
        this.entities = entities.data;
        this.page = entities.pagination.page;
        this.pageLength = entities.pagination.total;
      },
      (err: HttpErrorResponse) => {
        this.errorResponse = {
          title: 'Erro detectado',
          message: err.message,
          status: err.status.toString(),
          statusError: err.statusText
        } as IErrorResponse;
        this.displayError(err, true);
      },
      () => {
        this.loading = false;
        this.filterEntities = this.entities;
        this.filterEntities.length === 0
          ? (this.noResults = true)
          : (this.noResults = false);
      }
    );
  }

  openDialogFast(): void {
    if (this.insertType) {
      this.dialog
        .open(components[this.insertType].component, {
          ...components[this.insertType].config,
          disableClose: true,
          panelClass: ['dialog-sem-padding'],
          position: {
            top: '50px'
          },
          data: {
            ...components[this.insertType].config.data,
            ...this.data
          }
        })
        .afterClosed()
        .subscribe(componentEntity => {
          if (componentEntity) this.onLoadPagination(0, false, true);
        });
    }
  }

  get disabledClear() {
    var disabled = 0;
    this.dialogDataSearch.fields.forEach(keyword => {
      if (!keyword.control.value) disabled += 1;
    });
    return disabled === this.dialogDataSearch.fields.length;
  }

  /**
   * Entidades selecionadas
   */
  get selectedEntities(): any[] {
    return this.dataSelection;
  }

  /**
   * Entidades selecionadas
   */
  get selectedItensEntities(): any[] {
    return this.dataItensSelection;
  }

  /**
   * A Função que resgata o evento de mudança de página
   */
  handlePage(event): void {
    this.first = event.first;
    this.rows = event.rows;
    localStorage.setItem('PAGINATOR_SIZE', `${event.rows}`);
    if (this.stateSearch) this.onSearch(event.page);
    else this.onLoadPagination(event.page, false, true);
  }

  /**
   * A Função que resgata o evento de mudança de página
   */
  handlePageTableExpanded(event): void {
    this.first = event.first;
    this.rows = event.rows;
    localStorage.setItem('PAGINATOR_SIZE', `${event.rows}`);
    if (this.stateSearch) this.onSearch(event.page);
    else this.onLoadPagination(event.page, false, true);
  }

  /**
   * Caso o entity (Pai) seja deselecionado tem que ser observado se existia
   * algum filho selecionado na segunda tabela
   * @param event
   */
  rowUnselect(event) {
    this.idRowUnselect = event.data.id;
    this.selectionEntities([], true);
  }

  /**
   * Caso use TableExpanded o pai que for selecionado o filho também será
   * se tiver filhos
   * @param event
   */
  selectionEntities(event: any, rowIsUnselect = false) {
    var itens = [];
    if (event.length !== 0 && !rowIsUnselect) {
      event.forEach(select => {
        if (select.itens.length !== 0) {
          select.itens.forEach(it => {
            itens.push(it);
          });
        }
      });
      if (this.tableEntitiesExpanded) {
        if (this.tableEntitiesExpanded.selection.length !== 0) {
          this.tableEntitiesExpanded.selection.forEach(it => {
            const index = itens.findIndex(
              m => m[this.keyEntityCompare] === it[this.keyEntityCompare]
            );
            if (index >= 0) return;
            else {
              itens.push(it);
            }
          });
        }
        this.tableEntitiesExpanded.selection = itens;
        this.dataItensSelection = this.tableEntitiesExpanded.selection;
      } else {
        this.dataItensSelection = itens;
      }
    } else {
      if (this.tableEntitiesExpanded) {
        if (this.tableEntitiesExpanded.selection.length !== 0 && !rowIsUnselect)
          localStorage.setItem(
            'TEMP_ENTITIE_SELECTION',
            JSON.stringify(this.tableEntitiesExpanded.selection)
          );
        else if (
          this.tableEntitiesExpanded.selection.length !== 0 &&
          rowIsUnselect
        ) {
          this.tableEntitiesExpanded.selection.forEach(it => {
            if (it[this.keySubEntityCompare] !== this.idRowUnselect)
              itens.push(it);
          });
          this.idRowUnselect = '';
        } else {
          const selectionEntitiesTemp = JSON.parse(
            localStorage.getItem('TEMP_ENTITIE_SELECTION')
          );
          selectionEntitiesTemp.forEach(it => {
            if (it[this.keySubEntityCompare] !== this.idRowUnselect)
              itens.push(it);
          });
          this.idRowUnselect = '';
          localStorage.removeItem('TEMP_ENTITIE_SELECTION');
        }
        this.tableEntitiesExpanded.selection = itens;
        this.dataItensSelection = this.tableEntitiesExpanded.selection;
      } else {
        this.dataItensSelection = itens;
      }
    }
  }

  /**
   * Caso use TableExpanded se todos os filhos forem selecionados o pai também será
   * @param event
   */
  selectionItens(event: any) {
    var entities = [];
    var count = 0;
    if (this.tableExpanded && this.tableExpanded.value.length !== 0) {
      this.tableExpanded.value.forEach(ent => {
        if (event.length !== 0) {
          count = event.filter(
            it => it[this.keySubEntityCompare] === ent[this.keyEntityCompare]
          ).length;
          if (count === ent.itens.length) {
            count = 0;
            if (entities.length !== 0) {
              const index = entities.findIndex(
                m => m[this.keyEntityCompare] === ent[this.keyEntityCompare]
              );
              if (index >= 0) return;
              else {
                entities.push(ent);
              }
            } else {
              entities.push(ent);
            }
          }
          if (this.tableExpanded) {
            this.tableExpanded.selection = entities;
            this.dataSelection = this.tableExpanded.selection;
          } else {
            this.dataSelection = entities;
          }
        }
      });
    } else {
      if (this.tableExpanded) {
        this.tableExpanded.selection = entities;
        this.dataSelection = this.tableExpanded.selection;
      } else {
        this.dataSelection = entities;
      }
    }
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    this.loading = false;
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.dialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.showMessageObject(txtMsg);
    // errorMsg.checkError();
  }

  getMessageError() {
    if (!this.errorResponse) return '';
    return `Identificamos o erro ${this.errorResponse.status} - ${this.errorResponse.statusError} no processamento dos dados!`;
  }

  getFirstConfigPagination(){
    return this.page * (Number(localStorage.getItem('PAGINATOR_SIZE') || 5));
  }
}
